(function () {
if (window.owPlusInit) return; window.owPlusInit = 1;
var PLUS = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 3v18M3 12h18" stroke="currentColor" stroke-width="2"/></svg>';
function addPlus() {
document.querySelectorAll('.shopify-section--featured-collections product-card[handle], .shopify-section--main-collection product-card[handle]').forEach(function (c) {
var f = c.querySelector('.product-card__figure'); if (!f || f.querySelector('.ow-plus')) return;
var tt = (c.querySelector('.product-title') || {}).textContent || ''; if (/bundle/i.test(c.getAttribute('handle')) || /^\s*\d+\s*x\s/i.test(tt)) return;
var b = document.createElement('button');
b.type = 'button'; b.className = 'ow-plus';
b.setAttribute('data-ow-qb', c.getAttribute('handle'));
b.setAttribute('aria-label', 'Quick view');
b.innerHTML = PLUS;
f.appendChild(b);
});
}
var FAMILIES = 'Åre Beanie|Braided Golf Belt|Polo Belt|Suede Belt|Braided Belt|Double-Braided Bracelet|Beaded Bracelet|Silver Braid|Silver Cuff|Bracelet|Belt|Beanie';
var F_END = new RegExp('(' + FAMILIES + ')$', 'i'), F_START = new RegExp('^(' + FAMILIES + ')\\s+.+$', 'i');
var famMap = null, famByHandle = {};
function famOf(title) {
var t = String(title).replace(/\s+[–—-]\s+/g, ' ').replace(/\s+/g, ' ').trim();
if (/^\d+\s*x\s/i.test(t) || /bundle|gift/i.test(t)) return null;
var m = t.match(F_END); if (m && t.length > m[1].length) return m[1].toLowerCase();
var s = t.match(F_START); return s ? s[1].toLowerCase() : null;
}
function loadFamilies() {
if (famMap) return;
famMap = {};
function add(list) {
list.forEach(function (p) {
if (famByHandle[p.handle] !== undefined) return;
var f = famOf(p.title); famByHandle[p.handle] = f || null; if (!f) return;
var avail = (p.variants || []).some(function (v) { return v.available; }); if (!avail) return;
var img = p.images && p.images[0] ? p.images[0].src : '';
(famMap[f] = famMap[f] || []).push({ h: p.handle, t: p.title, i: img });
});
}
function all(url, n) {
return fetch(url + (url.indexOf('?') < 0 ? '?' : '&') + 'limit=250&page=' + n).then(function (r) { return r.json(); }).then(function (d) {
var list = d.products || []; add(list);
if (list.length >= 50 && n < 10) return all(url, n + 1);
});
}
all('/collections/bestsellers/products.json', 1).catch(function () {}).then(function () { return all('/products.json', 1); }).catch(function () {});
}
function ensureGroup(handle) {
var f = famByHandle[handle]; if (!f || !famMap || !famMap[f] || famMap[f].length < 2) return null;
var key = 'ow-fam-' + f.replace(/[^a-z0-9]+/g, '-');
var el = document.getElementById('ow-groups'), obj = {};
if (el) { try { obj = JSON.parse(el.textContent) || {}; } catch (e) { obj = {}; } }
if (!obj[key]) {
obj[key] = famMap[f].map(function (x) { return { h: x.h, t: x.t, i: img(x.i, 120) }; });
if (!el) { el = document.createElement('script'); el.type = 'application/json'; el.id = 'ow-groups'; document.body.appendChild(el); }
el.textContent = JSON.stringify(obj);
}
return key;
}
var qb = null, qbState = null, pcache = {};
function esc(t) { return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
function getP(h) { return pcache[h] ? Promise.resolve(pcache[h]) : fetch('/products/' + h + '.js').then(function (r) { return r.json(); }).then(function (p) { pcache[h] = p; return p; }); }
function img(src, w) { if (!src) return ''; src = String(src); if (src.indexOf('//') === 0) src = 'https:' + src; return src + (src.indexOf('?') < 0 ? '?' : '&') + 'width=' + w; }
function money(c) {
var cur = window.Shopify && Shopify.currency && Shopify.currency.active || 'SEK', a = c / 100;
if (cur === 'SEK') return Math.round(a).toLocaleString('sv-SE') + ' kr';
try { return new Intl.NumberFormat('sv-SE', { style: 'currency', currency: cur }).format(a); } catch (e) { return a.toFixed(2) + ' ' + cur; }
}
function colorName(title, fam) {
var t = String(title).replace(/\s+[–—-]\s+/g, ' ').replace(/\s+/g, ' ').trim();
if (!fam) return '';
var re = new RegExp(fam.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'i');
return t.replace(re, '').replace(/\s+/g, ' ').trim();
}
function famTitle(p) { var f = famByHandle[p.handle]; if (!f) return p.title; var m = p.title.match(new RegExp(f.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'i')); return m ? m[0] : p.title; }
function sizeIdx(p) {
if (!p.options || !p.options.length) return -1;
for (var i = 0; i < p.options.length; i++) { if (/size|storlek|størrelse|amount|belopp/i.test(p.options[i].name || p.options[i])) return i; }
return p.options.length === 1 && p.variants.length > 1 ? 0 : -1;
}
function sizeLabel(t) { var m = String(t).trim().match(/^(\d+(?:[.,]\d+)?)\s*cm$/i); return m ? m[1] + ' CM' : t; }
function firstAvail(p) { return p.variants.filter(function (v) { return v.available; })[0] || p.variants[0]; }
function qbRender() {
var p = qbState.p, v = qbState.v, f = famByHandle[p.handle], sibs = (f && famMap && famMap[f]) || [];
var si = sizeIdx(p);
var colorsHtml = '';
if (sibs.length > 1) {
colorsHtml = '<p class="ow-qb__legend">Color:<span data-qb-color>' + esc(colorName(p.title, f) || p.title) + '</span></p><div class="ow-qb__colors">' +
sibs.map(function (s) { return '<button type="button" class="ow-qb__color' + (s.h === p.handle ? ' is-active' : '') + '" data-qb-sib="' + esc(s.h) + '" aria-label="' + esc(colorName(s.t, f)) + '"><img src="' + esc(img(s.i, 160)) + '" alt="" loading="lazy"></button>'; }).join('') + '</div>';
}
var sizesHtml = '';
if (si > -1) {
var key = 'option' + (si + 1);
sizesHtml = '<p class="ow-qb__legend">Size:<span data-qb-size>' + esc(sizeLabel(v[key])) + '</span></p>' + (p.variants.length < 2 ? '' : '<div class="ow-qb__sizes">' +
p.variants.map(function (x) { return '<button type="button" class="ow-qb__size' + (x.id === v.id ? ' is-active' : '') + '" data-qb-var="' + x.id + '"' + (x.available ? '' : ' disabled') + '>' + esc(sizeLabel(x[key])) + '</button>'; }).join('') + '</div>');
}
var pimg = (v.featured_image && v.featured_image.src) || p.featured_image;
qb.querySelector('[data-qb-panel]').innerHTML =
'<div class="ow-qb__head"><button type="button" class="ow-qb__x" data-qb-close aria-label="Close"><svg viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="m1 1 14 14M1 15 15 1" stroke="currentColor" stroke-width="1.5"/></svg></button><img class="ow-qb__img" data-qb-img src="' + esc(img(pimg, 240)) + '" alt=""><div><a class="ow-qb__title" href="/products/' + esc(p.handle) + '">' + esc(famTitle(p)) + '</a><div class="ow-qb__price" data-qb-price>' + (v.compare_at_price > v.price ? '<s>' + money(v.compare_at_price) + '</s>' : '') + money(v.price) + '</div></div></div>' +
((colorsHtml || sizesHtml) ? '<div class="ow-qb__body">' + colorsHtml + sizesHtml + '</div>' : '') +
'<div class="ow-qb__foot"><button type="button" class="ow-qb__add" data-qb-add' + (v.available ? '' : ' disabled') + '>' + (v.available ? 'Add to cart' : 'Sold out') + '</button></div>';
}
function qbClose() {
if (!qb) return; var el = qb; qb = null; qbState = null;
el.classList.remove('is-open'); document.documentElement.classList.remove('ow-qb-lock');
document.removeEventListener('keydown', qbKey);
setTimeout(function () { el.remove(); }, 300);
}
function qbKey(e) { if (e.key === 'Escape') qbClose(); }
function qbOpen(handle) {
loadFamilies();
getP(handle).then(function (p) {
if (qb) qb.remove();
qb = document.createElement('div'); qb.className = 'ow-qb'; qb.setAttribute('role', 'dialog'); qb.setAttribute('aria-modal', 'true');
qb.innerHTML = '<div class="ow-qb__overlay" data-qb-close></div><button type="button" class="ow-qb__close" data-qb-close aria-label="Close"><svg viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="m1 1 14 14M1 15 15 1" stroke="currentColor" stroke-width="1.5"/></svg></button><div class="ow-qb__panel" data-qb-panel></div>';
document.body.appendChild(qb);
qbState = { p: p, v: firstAvail(p) }; qbRender();
document.documentElement.classList.add('ow-qb-lock');
document.addEventListener('keydown', qbKey);
void qb.offsetWidth; qb.classList.add('is-open');
var f = famByHandle[p.handle]; ((f && famMap && famMap[f]) || []).forEach(function (s) { getP(s.h); });
});
}
/* Added-to-cart view like ICON (OneWear blue and white) */
var DONE_CSS = '.ow-qb__done{display:grid;gap:32px;padding:24px;text-align:start}.ow-qb__ok{display:flex;align-items:center;justify-content:center;gap:14px;padding:14px;background:rgb(230,247,237);color:rgb(50,185,104);font-size:12px;line-height:19.2px}.ow-qb__ok svg{width:18px;height:18px;flex-shrink:0}.ow-qb__line{display:flex;align-items:center;gap:24px}.ow-qb__line img{width:80px;height:120px;object-fit:cover;flex-shrink:0;display:block}.ow-qb__lt{display:block;font-size:12px;font-weight:600;line-height:19.2px;text-transform:uppercase;color:#000;text-decoration:none}.ow-qb__lp{margin-top:2px;font-size:12px;font-weight:600;line-height:19.2px;color:#000}.ow-qb__vt{margin:4px 0 0;font-size:12px;line-height:19.2px;color:rgba(0,0,0,.7)}.ow-qb__btns{display:grid;grid-template-columns:1fr;gap:8px}.ow-qb__btns a{display:flex;align-items:center;justify-content:center;box-sizing:border-box;min-height:43px;padding:12px 24px;font-size:12px;font-weight:600;line-height:19.2px;letter-spacing:.6px;text-transform:uppercase;text-decoration:none;border:1px solid #1f2942}.ow-qb__vc{background:#fff;color:#1f2942}.ow-qb__co{background:#1f2942;color:#fff}@media screen and (min-width:700px){.ow-qb__btns{grid-template-columns:1fr 1fr}.ow-qb__vc{text-transform:none!important}}';
function qbDone(it) {
if (!qb || !it) { qbClose(); return; }
if (!document.getElementById('ow-qb-done-css')) { var st = document.createElement('style'); st.id = 'ow-qb-done-css'; st.textContent = DONE_CSS; document.head.appendChild(st); }
var im = (it.featured_image && it.featured_image.url) || it.image || '';
var vt = it.variant_title && !/default title/i.test(it.variant_title) ? it.variant_title : '';
qb.classList.add('is-done');
qb.querySelector('[data-qb-panel]').innerHTML = '<div class="ow-qb__done" role="status">' +
'<div class="ow-qb__ok"><svg viewBox="0 0 18 18" fill="none" aria-hidden="true"><circle cx="9" cy="9" r="9" fill="currentColor"/><path d="m5.5 9.2 2.3 2.3 4.7-4.7" stroke="#fff" stroke-width="1.6"/></svg>Added to your cart!</div>' +
'<div class="ow-qb__line">' + (im ? '<img src="' + esc(img(im, 240)) + '" alt="">' : '') + '<div><a class="ow-qb__lt" href="' + esc(it.url || '#') + '">' + esc(it.product_title || it.title) + '</a><div class="ow-qb__lp">' + money(it.final_line_price != null ? it.final_line_price : it.line_price) + '</div>' + (vt ? '<p class="ow-qb__vt">' + esc(vt) + '</p>' : '') + '</div></div>' +
'<div class="ow-qb__btns"><a href="/cart" class="ow-qb__vc" data-qb-viewcart>View cart</a><a href="/checkout" class="ow-qb__co">Checkout securely</a></div></div>';
}
function qbAdd(btn) {
var v = qbState && qbState.v; if (!v || !v.available) return;
btn.disabled = true; btn.textContent = 'Adding...';
fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] }) })
.then(function (r) { if (!r.ok) throw r; return r.json(); })
.then(function (d) {
document.dispatchEvent(new CustomEvent('cart:refresh'));
qbDone(d && d.items ? d.items[0] : d);
})
.catch(function () { btn.disabled = false; btn.textContent = 'Could not add, try again'; });
}
document.addEventListener('click', function (e) {
var t = e.target; if (!t || !t.closest) return;
var o = t.closest('[data-ow-qb]');
if (o) { e.preventDefault(); e.stopPropagation(); qbOpen(o.getAttribute('data-ow-qb')); return; }
if (!qb || !qb.contains(t)) return;
if (t.closest('[data-qb-close]')) { qbClose(); return; }
var vc = t.closest('[data-qb-viewcart]');
if (vc) { var cd0 = drawer(); if (cd0 && typeof cd0.show === 'function') { e.preventDefault(); qbClose(); setTimeout(function () { cd0.show(); }, 250); } return; }
var sib = t.closest('[data-qb-sib]');
if (sib) {
var h = sib.getAttribute('data-qb-sib'); if (h === qbState.p.handle) return;
getP(h).then(function (p) { if (!qb) return; qbState = { p: p, v: firstAvail(p) }; qbRender(); });
return;
}
var sz = t.closest('[data-qb-var]');
if (sz && !sz.disabled) {
var id = parseInt(sz.getAttribute('data-qb-var'), 10);
qbState.v = qbState.p.variants.filter(function (x) { return x.id === id; })[0] || qbState.v; qbRender(); return;
}
var add = t.closest('[data-qb-add]'); if (add && !add.disabled) qbAdd(add);
}, true);
var lb = null, lbN = 0;
function lbTrack() { return lb && lb.querySelector('.ow-lb__track'); }
function lbIdx() { var t = lbTrack(); return t ? Math.round(t.scrollLeft / (t.clientWidth || 1)) : 0; }
function lbGo(d) { var t = lbTrack(); if (!t) return; var i = (lbIdx() + d + lbN) % lbN; t.scrollTo({ left: i * t.clientWidth, behavior: Math.abs(d) === 1 && !((lbIdx() === lbN - 1 && d > 0) || (lbIdx() === 0 && d < 0)) ? 'smooth' : 'auto' }); }
function lbKey(e) { if (e.key === 'Escape') lbClose(); else if (e.key === 'ArrowRight') lbGo(1); else if (e.key === 'ArrowLeft') lbGo(-1); }
function lbClose() { if (!lb) return; lb.remove(); lb = null; document.documentElement.classList.remove('ow-qb-lock'); document.removeEventListener('keydown', lbKey); }
function lbOpen(srcs, i) {
lbN = srcs.length;
var ch = '<svg viewBox="0 0 8 14" fill="none" aria-hidden="true"><path d="M1 1l6 6-6 6" stroke="currentColor" stroke-width="1.5"/></svg>';
lb = document.createElement('div'); lb.className = 'ow-lb'; lb.setAttribute('role', 'dialog'); lb.setAttribute('aria-modal', 'true');
lb.innerHTML = '<button type="button" class="ow-lb__close" data-lb-close aria-label="Close"><svg viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="m1 1 14 14M1 15 15 1" stroke="currentColor" stroke-width="1.5"/></svg></button><div class="ow-lb__track">' +
srcs.map(function (s) { return '<div class="ow-lb__slide"><img src="' + esc(s) + '" alt=""></div>'; }).join('') + '</div>' +
(lbN > 1 ? '<div class="ow-lb__pag"><button type="button" data-lb-prev aria-label="Previous" style="transform:scaleX(-1)">' + ch + '</button><span><span data-lb-cur>' + (i + 1) + '</span> / ' + lbN + '</span><button type="button" data-lb-next aria-label="Next">' + ch + '</button></div>' : '');
document.body.appendChild(lb);
document.documentElement.classList.add('ow-qb-lock');
document.addEventListener('keydown', lbKey);
var t = lbTrack(); t.scrollLeft = i * t.clientWidth;
t.addEventListener('scroll', function () { var c = lb && lb.querySelector('[data-lb-cur]'); if (c) c.textContent = lbIdx() + 1; }, { passive: true });
}
function big(src) { src = String(src || ''); if (src.indexOf('//') === 0) src = 'https:' + src; return /[?&]width=\d+/.test(src) ? src.replace(/([?&])width=\d+/, '$1width=1800') : src + (src.indexOf('?') < 0 ? '?' : '&') + 'width=1800'; }
document.addEventListener('click', function (e) {
var t = e.target; if (!t || !t.closest) return;
if (lb) {
if (t.closest('[data-lb-close]')) { lbClose(); return; }
if (t.closest('[data-lb-prev]')) { lbGo(-1); return; }
if (t.closest('[data-lb-next]')) { lbGo(1); return; }
return;
}
var m = t.closest('.shopify-section--main-product .product-gallery__media'); if (!m || !m.querySelector('img')) return;
var g = m.closest('.product-gallery') || m.parentElement;
var list = Array.prototype.filter.call(g.querySelectorAll('.product-gallery__media'), function (x) { return x.querySelector('img') && !x.hidden && getComputedStyle(x).display !== 'none'; });
var i = list.indexOf(m); if (i < 0) return;
e.preventDefault(); e.stopPropagation();
lbOpen(list.map(function (x) { var im = x.querySelector('img'); return big(im.getAttribute('src') || im.currentSrc); }), i);
}, true);
var pageOpen = false, seen = false, added = false;
function drawer() { return document.getElementById('cart-drawer'); }
document.addEventListener('click', function (e) {
var t = e.target && e.target.closest && e.target.closest('[data-ow-page]'); if (!t) return;
var cd = drawer(); if (!cd || typeof cd.show !== 'function') return;
e.preventDefault();
var g = ensureGroup(t.getAttribute('data-ow-qv'));
if (g) t.setAttribute('data-ow-group', g); else t.removeAttribute('data-ow-group');
if (!cd.hasAttribute('open')) { pageOpen = true; seen = false; added = false; cd.classList.add('ow-qv-pending'); cd.show(); }
}, true);
document.addEventListener('cart:refresh', function () { added = true; });
var apT = null;
new MutationObserver(function () {
clearTimeout(apT); apT = setTimeout(addPlus, 150);
var cd = drawer(); if (!cd) return;
if (!pageOpen) { cd.classList.remove('ow-qv-pending'); return; }
if (!cd.hasAttribute('open')) { pageOpen = false; cd.classList.remove('ow-qv-pending'); return; }
if (cd.querySelector('.ow-qv')) { seen = true; return; }
if (seen) {
pageOpen = false;
if (!added && typeof cd.hide === 'function') { cd.hide(); setTimeout(function () { cd.classList.remove('ow-qv-pending'); }, 400); }
else cd.classList.remove('ow-qv-pending');
}
}).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['open'] });
function boot() { addPlus(); setTimeout(loadFamilies, 300); }
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
document.addEventListener('shopify:section:load', addPlus);
})();